import { createContext, useContext } from 'react';

const emptyShowSeasonFilterContextValue = {
    seasonId: null,
    seasonName: null,
    seasonModelsByModelId: new Map(),
    isLoadingSeasonDetails: false,
};

export const ShowSeasonFilterContext = createContext(emptyShowSeasonFilterContextValue);

export function useShowSeasonFilterContext() {
    return useContext(ShowSeasonFilterContext);
}

export const ShowSeasonFilterProvider = ({ value, children }) => {
    return <ShowSeasonFilterContext.Provider value={value}>{children}</ShowSeasonFilterContext.Provider>;
};
